import { mapGetters } from 'vuex';
// import { PERMISSIONS } from '@/constants/permissions';

export default {
  computed: {
    ...mapGetters(['getUser', 'getUserRoles']),

    /**
     * Determines if the current page should be in readonly mode
     * @returns {boolean} True if page should be readonly
     */
    isReadonlyMode() {

      const user = JSON.parse(localStorage.getItem('user'));
      let isKenyaOrPtsiClient = false;
      if(user){
        isKenyaOrPtsiClient = user?.user_role_assoc?.some(role => 
          role.id === 'indonesia_admin' || role.id === 'naccu_kenya_admin'
        );
      }

      // const moduleAndPermissions = JSON.parse(localStorage.getItem('moduleAndPermissions') || '[]');

      // const permissionValue = PERMISSIONS.can_eudr_report_create_update.value;

      // const hasPermission = moduleAndPermissions.some(permission => {
      //   const moduleId = permission.module_id || '';

      //   const moduleContainsPermission = moduleId.includes(permissionValue);

      //   return moduleContainsPermission;
      // });

      // console.log("hasPermission:", hasPermission);
      
      // Get the diligence report data to check for assignment and requestAdditionalInformation
      const diligenceDetails = this.$store.getters["eudrDDS/getDiligenceDetails"];
      console.log("diligenceDetails:", diligenceDetails);
      
      // Check if DDS is assigned to a worker from parent organization
      const isAssignedToWorker = diligenceDetails?.assignedTo && diligenceDetails?.assignedToCfId;
      
      // Determine if there is an OPEN additional information request (pending)
      // Prefer Vuex list; fallback to report details if store list is empty
      let latestAdditionalInfo = this.$store.getters["eudrDDS/ddsAdditionalInformationByDiligenceIdLatest"];
      if (!latestAdditionalInfo && Array.isArray(diligenceDetails?.requestAdditionalInformation) && diligenceDetails.requestAdditionalInformation.length > 0) {
        const sorted = [...diligenceDetails.requestAdditionalInformation].sort((a, b) => (parseInt(b?.id || 0, 10)) - (parseInt(a?.id || 0, 10)));
        latestAdditionalInfo = sorted[0];
      }
      console.log(latestAdditionalInfo, 'latestAdditionalInfo');
      const normalizedStatus = latestAdditionalInfo?.status ? latestAdditionalInfo.status.toString().toLowerCase() : null;
      const hasOpenAdditionalInfo = normalizedStatus === 'pending';

      console.log(isAssignedToWorker, 'isAssignedToWorker');
      console.log(hasOpenAdditionalInfo, 'hasOpenAdditionalInfo');
      console.log(isKenyaOrPtsiClient, 'isKenyaOrPtsiClient');

      // If user is NOT Kenya/PTSI, never readonly
      if (!isKenyaOrPtsiClient) {
        return false;
      }
      
      // - Can edit until DDS is assigned to a worker
      // - Once assigned, can only edit if worker requests additional information
      if (isKenyaOrPtsiClient) {
        if (typeof isAssignedToWorker !== 'undefined' && isAssignedToWorker !== null && !isAssignedToWorker) {
          // Not assigned yet - cooperative can edit
          return false;
        } 
        else if(this.$route.name === 'createDueDiligenceReports' && !this.$route.params.show){
          return false; // for create due diligence report page
        }
        else {
          // Assigned to worker - only editable if additional info requested
          return !hasOpenAdditionalInfo;
        }
      }
      

      return false; // default no readonly
      
      // For Kenya/PTSI admin users, editable if either condition below is true
      // const canEdit = (!hasShowParam) || hasRequestAdditionalInfo;
      // return !canEdit;
      
    },

    /**
     * Get readonly props for form components
     * @returns {Object} Props object for readonly state
     */
    readonlyProps() {
      return {
        readonly: this.isReadonlyMode,
        disabled: this.isReadonlyMode
      };
    },

    /**
     * Get readonly attributes for input components
     * @returns {Object} Attributes object for readonly state
     */
    readonlyAttrs() {
      return {
        readonly: this.isReadonlyMode,
        disabled: this.isReadonlyMode
      };
    }
  },

  methods: {
    /**
     * Check if a specific field should be readonly
     * @returns {boolean} True if field should be readonly
     */
    isFieldReadonly() {
      return this.isReadonlyMode;
    },

    /**
     * Get readonly state for v-text-field components
     * @returns {Object} Props for v-text-field
     */
    getTextFieldProps() {
      return {
        readonly: this.isReadonlyMode,
        disabled: this.isReadonlyMode,
        outlined: !this.isReadonlyMode,
        filled: this.isReadonlyMode
      };
    },

    /**
     * Get readonly state for v-select components
     * @returns {Object} Props for v-select
     */
    getSelectProps() {
      return {
        readonly: this.isReadonlyMode,
        disabled: this.isReadonlyMode,
        outlined: !this.isReadonlyMode,
        filled: this.isReadonlyMode
      };
    },

    /**
     * Get readonly state for v-textarea components
     * @returns {Object} Props for v-textarea
     */
    getTextareaProps() {
      return {
        readonly: this.isReadonlyMode,
        disabled: this.isReadonlyMode,
        outlined: !this.isReadonlyMode,
        filled: this.isReadonlyMode
      };
    },

    /**
     * Get readonly state for v-checkbox components
     * @returns {Object} Props for v-checkbox
     */
    getCheckboxProps() {
      return {
        disabled: this.isReadonlyMode,
        readonly: this.isReadonlyMode
      };
    },

    /**
     * Get readonly state for v-radio-group components
     * @returns {Object} Props for v-radio-group
     */
    getRadioGroupProps() {
      return {
        disabled: this.isReadonlyMode,
        readonly: this.isReadonlyMode
      };
    },

    /**
     * Get readonly state for v-btn components (save/submit buttons)
     * @returns {Object} Props for v-btn
     */
    getButtonProps() {
      return {
        disabled: this.isReadonlyMode,
        readonly: this.isReadonlyMode
      };
    }
  }
};
